"use client";
import { Space } from "antd";
import PeopleAlsoWatch from "@/app/components/products/PeopleAlsoWatch";
import ProductSignal from "@/app/components/products/Singal";
import SignalDetails from "@/app/components/products/ProductSignals/Details";

function ProductSignals({ symbol }: { symbol: string }) {
  return (
    <Space direction={"vertical"} size={"large"} className={"w-full"}>
      <ProductSignal symbol={symbol} />
      <SignalDetails symbol={symbol || ""} />
      <PeopleAlsoWatch symbol={symbol} />
    </Space>
  );
}

export default ProductSignals;
